export const CHART_WIDGET_TYPES = new Set([
  "chart",
  "chart-old",
  "midstream-chart",
  "midstream-chart-old"
]);
